"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    fireBlightTRV: _aggregation_helpers_1.dailyOrHourlyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=fire_blight.js.map